import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/50" role="contentinfo">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-calligraphy text-xl text-primary-500 mb-4">
              <Link to="/" className="cursor-pointer">星空电影</Link>
            </h4>
            <p className="text-foreground-500 text-sm leading-relaxed">
              星空电影网致力于为广大影迷提供最新、最全、最高清的电影资源。分类清晰，片单齐全，找片看片一站搞定。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-100 mb-4">
              电影分类
            </h4>
            <ul className="space-y-2">
              {[
                { name: '动作片', path: '/category/action' },
                { name: '喜剧片', path: '/category/comedy' },
                { name: '科幻片', path: '/category/scifi' },
                { name: '动画片', path: '/category/animation' },
                { name: '悬疑片', path: '/category/suspense' },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-100 mb-4">
              更多分类
            </h4>
            <ul className="space-y-2">
              {[
                { name: '爱情片', path: '/category/romance' },
                { name: '恐怖片', path: '/category/horror' },
                { name: '战争片', path: '/category/war' },
                { name: '热门推荐', path: '/' },
                { name: '最新电影', path: '/' },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-100 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-foreground-500 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <p className="text-foreground-500 text-sm">
                  邮箱: contact@xingkongmovie.com
                </p>
              </li>
              <li>
                <p className="text-foreground-500 text-sm">
                  客服: 400-888-6666
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-600 text-xs">
            &copy; {currentYear} 星空电影网 xingkongmovie.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-foreground-600 hover:text-primary-400 text-xs transition-colors"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-foreground-600 hover:text-primary-400 text-xs transition-colors"
              rel="nofollow"
            >
              服务条款
            </a>
            <a
              href="#"
              className="text-foreground-600 hover:text-primary-400 text-xs transition-colors"
              rel="nofollow"
            >
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}